import { Channel, Program } from '../types';

export const channels: Channel[] = [
  {
    id: '1',
    name: 'Canal Principal',
    stream: 'livestream6',
    description: 'Programação variada 24 horas',
    logo: '📺',
    thumbnail: 'https://images.unsplash.com/photo-1586899028174-e7098604235b?w=800&auto=format&fit=crop&q=60'
  },
  {
    id: '2',
    name: 'Canal Notícias',
    stream: 'livestream',
    description: 'As últimas notícias do dia',
    logo: '🔴',
    thumbnail: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?w=800&auto=format&fit=crop&q=60'
  },
  {
    id: '3',
    name: 'Canal Entretenimento',
    stream: 'livestream2',
    description: 'Filmes e séries para toda família',
    logo: '🎬',
    thumbnail: 'https://images.unsplash.com/photo-1578022761797-b8636ac1773c?w=800&auto=format&fit=crop&q=60'
  }
];

export const programs: Program[] = [
  {
    id: '1',
    title: 'Jornal da Manhã',
    description: 'As principais notícias do dia',
    startTime: '06:00',
    endTime: '08:00',
    channelId: '1'
  },
  {
    id: '2',
    title: 'Filme da Tarde',
    description: 'Filmes selecionados para toda família',
    startTime: '14:00',
    endTime: '16:00',
    channelId: '1'
  },
  {
    id: '3',
    title: 'Notícias 24h',
    description: 'Cobertura completa dos acontecimentos',
    startTime: '00:00',
    endTime: '23:59',
    channelId: '2'
  },
  {
    id: '4',
    title: 'Filmes e Séries',
    description: 'Programação especial de entretenimento',
    startTime: '00:00',
    endTime: '23:59',
    channelId: '3'
  }
];